var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip479_10311"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "36 Stroke / ds_ic_36_heart",
    width: 36,
    height: 36,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip479_10311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M28.6494 8.3584C25.8062 5.50781 21.3594 5.2417 18.2173 7.56055L18 7.72656L17.7832 7.56055C14.6401 5.2417 10.1934 5.50781 7.3501 8.3584C4.21582 11.5005 4.21582 16.5952 7.3501 19.7388L17.292 29.7065C17.6831 30.0986 18.3174 30.0986 18.7085 29.7065L28.6494 19.7388C31.7837 16.5952 31.7837 11.5005 28.6494 8.3584ZM27.2329 18.3262C29.5889 15.9639 29.5889 12.1323 27.2334 9.77051C24.8789 7.41064 21.0625 7.41064 18.7085 9.77051C18.3174 10.1626 17.6831 10.1626 17.2925 9.771C14.937 7.41016 11.1206 7.41016 8.76611 9.77051C6.41064 12.1323 6.41064 15.9639 8.76611 18.3262L18 27.5845L27.2329 18.3262ZM26.3877 17.0142L21.708 21.7061C21.3179 22.0972 20.6846 22.0981 20.2935 21.708C19.9028 21.3179 19.9019 20.6846 20.292 20.2939L24.9717 15.6016C25.3618 15.2109 25.9951 15.21 26.3862 15.6001C26.7769 15.9902 26.7778 16.623 26.3877 17.0142Z",
    clipRule: "evenodd",
    fill: "#50964E",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotification);
export default __webpack_public_path__ + "static/media/ic_notification.bf0dd5c30bb69126a872ff77f0112b7f.svg";
export { ForwardRef as ReactComponent };